/* Status updates, ability to cancel --- progress indicator instead of spinning gif */

require('./index.less');

var Modal = require('../modal/modal'),
    Marionette = require('marionette'),
    _ = require('underscore');

module.exports = Modal.extend({
    modalSettings: {    //these don't change -- settings for the modal
        showDismissBtn: false,
        overlay: false,
        hideFooter: true
    },
    defaults: { //(the 'content' of key of modal defaults -- set from options passed here
        heading: 'Loading ...',
        status: '',
        startPct: 0,
        enableCancel: true,
        cancelTitle: 'Cancel'
    },
    initialize: function(options) {
        var childTemplate = require('./modal-progress.hbs'), //loaded inside body of super
            subMarkup = childTemplate( _.extend( {}, this.defaults, options ) );
        this.settings = _.extend( {}, {
            content: subMarkup /* Note: non jquery markup inserted into template body */
        }, options );
        Modal.prototype.initialize.call( this, _.extend( {}, this.settings, this.modalSettings ) );
        return this;
    },
    ui: {
        cancelBtn:      '#progress-cancel',
        status:         '.status-msg',
        progressBar:    '.bar'
    },
    events: {
        'click @ui.cancelBtn': 'cancel'
    },
    keyboardEvents: {}, //override: don't allow escape to close
    onUpdateStatus: function(nComplete, nTotal, statusMessage) { //status message is optional (its the friendly desc from the jq plugin)

        // Prevent err updating ref to ui if destroyed first ... onCancel which destroy the view could run before this is called ...
        if (this.isDestroyed)
            return false;

        var pct = String( Math.round( (nComplete / nTotal) * 100 ) ) + '%'; //must be string so jquery keeps %

        if (statusMessage)
            this._updateStatusMsg(statusMessage);

        this.ui.progressBar.css( 'width', pct );
    },
    cancel: function() {
        this._updateStatusMsg('Cancelling...');
        this.settings.onCancel && this.settings.onCancel.call(this); //(left of to caller to close on cancel) -- could be
    },
    _updateStatusMsg: function(msg) {
        // If entering here when destroyed already called, there will be an error referencing this.ui.status (it will be a str).
        if (this.isDestroyed)
            return false;
        this.ui.status.text(msg);
    }
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/common/modalLoading/modalLoading.js
 ** module id = 751
 ** module chunks = 0
 **/